import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/comicData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            goTo("home");
          }}
          className="flex items-center gap-2.5 whitespace-nowrap"
        >
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
            }`}
          >
            <i className="ri-sparkling-2-line text-lg" />
          </span>
          <span
            className={`font-heading text-xl md:text-2xl font-bold ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            虚空漫画网
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => {
                e.preventDefault();
                goTo(item.id);
              }}
              className={`rounded-md px-3.5 py-2 text-sm whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                  : "text-background-100/90 hover:bg-white/10 hover:text-background-50"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#entrance"
            onClick={(e) => {
              e.preventDefault();
              goTo("entrance");
            }}
            className="hidden items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            立即进入
            <i className="ri-arrow-right-up-line" />
          </a>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
              scrolled
                ? "bg-background-100 text-foreground-900"
                : "bg-white/10 text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  goTo(item.id);
                }}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#entrance"
              onClick={(e) => {
                e.preventDefault();
                goTo("entrance");
              }}
              className="mt-2 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 whitespace-nowrap"
            >
              立即进入阅读
              <i className="ri-arrow-right-up-line" />
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}